// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"53":"950404e3","142":"a0ac1163","199":"e7a548a5","222":"7afd6556","282":"88f969f3","317":"e4052423","354":"a828e6a6","415":"93d561d1","418":"a8d65bd5","444":"ec16d98e","502":"811030ed","750":"1c1fd9e3","923":"f6117cf2"}[chunkId] + ".js";
};